<style lang="postcss">
	.select-embed-item {
		display: flex;
		max-height: 100%;
		flex: none;
		min-width: 0;
		align-items: center;
	}
	.select-embed-item > img {
		width: 90%;
		border-radius: 2px;
	}
</style>

<script lang="ts">
	import { getImageSrc } from "$lib/helpers/functions";
	export let embed: Embed | null | undefined = null;
	export let width: string = "1.2rem";
	export let hasDescription: boolean = false;
	export let rounded: boolean = false;
</script>

{#if embed}
	{#if embed.type === "svg"}
		{@const url = getImageSrc(embed)}
		<span
			style="width: {width}; margin-right: {hasDescription
				? '0.375rem'
				: '0.375rem'}; padding: {hasDescription ? '4px 0 0' : '2.1px 0'}"
			class="{$$props.class || ''} select-embed-item">
			{#if embed.source === "svg_url"}
				<img
					style="{rounded ? 'border-radius: .25rem' : ''}"
					loading="lazy"
					src="{url}"
					alt="" />
			{:else}
				{@html embed.content}
			{/if}
		</span>
	{:else if embed.type === "emoji"}
		<span
			style="{hasDescription
				? 'font-size: 1.9rem; line-height: 1.1rem'
				: 'font-size: 1.05rem; line-height: 1.1'}; width: {width}; margin-right: {hasDescription
				? '0.375rem'
				: '0.375rem'}; padding: {hasDescription ? '4px 0 0' : '2.1px 0'}"
			class="{$$props.class || ''} select-embed-item">
			{@html embed.content}
		</span>
	{:else if embed.type === "image"}
		{@const url = getImageSrc(embed)}
		<span
			style="width: {width}; margin-right: {hasDescription
				? '0.375rem'
				: '0.375rem'}; padding: {hasDescription ? '4px 0 0' : '2.1px 0'}"
			class="{$$props.class || ''} select-embed-item">
			<img
				style="{rounded ? 'border-radius: .25rem' : ''}"
				loading="lazy"
				src="{url}"
				width="{embed.width ?? 256}"
				height="{embed.width ?? 256}"
				alt="" />
		</span>
	{/if}
{/if}
